// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../const/ApiEndPoints';
import { useCallback } from 'react';

export default function useLog() {
  const getLogActionsAttributes = (body, loader = true) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_LOG_ACTIONS_ATTRIBUTES}`,
        body,
        { loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const downloadLogs = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNLOAD_LOGS}`,
        body,
        {
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getLogActions = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_LOG_ACTIONS}`,
        {
          params: body,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getLogstates = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_LOG_STATE}`,
        {
          params: body,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getHistory = useCallback((body, loader = true) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.HISTORY}`,
        body,
        { loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    getLogActionsAttributes,
    getLogActions,
    downloadLogs,
    getHistory,
    getLogstates,
  };
}
